import { z } from 'zod/v4';
import {
  AssessmentNoteResourceSchema,
  CreateAssessmentNoteBodySchema,
  DeleteAssessmentNoteParamsSchema,
  ListAssessmentNotesQuerySchema,
} from '../schemas/assessment-note.js';

/**
 * `POST /risk-analysis/assessment-notes` — add a note to an assessment risk.
 *
 * Replaces legacy `POST /risk-analysis-service/v3/assessment-notes/`.
 */
export const CreateAssessmentNoteContract = {
  method: 'POST',
  path: '/risk-analysis/assessment-notes',
  body: CreateAssessmentNoteBodySchema,
  response: AssessmentNoteResourceSchema,
} as const;

/**
 * `DELETE /risk-analysis/assessment-notes/:id` — remove a note the caller
 * authored. Replies 204 with no body.
 *
 * Replaces legacy `DELETE /risk-analysis-service/v3/assessment-notes/:id`.
 */
export const DeleteAssessmentNoteContract = {
  method: 'DELETE',
  path: '/risk-analysis/assessment-notes/:id',
  params: DeleteAssessmentNoteParamsSchema,
} as const;

/**
 * `GET /risk-analysis/assessment-notes` — list notes for one assessment risk,
 * paginated. Replies with the legacy `{ data, meta }` envelope.
 *
 * Replaces legacy `GET /risk-analysis-service/v3/assessment-notes/`.
 */
export const ListAssessmentNotesContract = {
  method: 'GET',
  path: '/risk-analysis/assessment-notes',
  query: ListAssessmentNotesQuerySchema,
  response: z.object({
    data: z.array(AssessmentNoteResourceSchema),
    meta: z.object({
      count: z.number(),
      page: z.number(),
      pageSize: z.number(),
      totalCount: z.number(),
    }),
  }),
} as const;
